<template>
	<transition name="slide-fade">
		<div>
			<div class="text-yellow px-2">
				<p>NOTE: This procedure will skip any duplicate NSIM GT configurations. The Clear Data button will remove all configurations from the database.</p>
			</div>
			<div class="form-group row mb-1">
				<div class="col-sm-3">
					<div class="custom-file">
						<input type="hidden" id="nsimgt-csv-input-file-value">
						<input type="file" accept=".csv" class="custom-file-input" id="nsimgt-csv-input-file" @change="handleFileInputChange">
						<label class="custom-file-label" for="suspend-input-file" id="nsimgt-csv-input-file-label">Choose file</label>
					</div>
				</div>

				<div class="col-sm-9">
					<!-- <b-button variant="success" @click="previewData">Preview Data</b-button> -->
					<b-button variant="warning" @click="downloadCsv">Download Data</b-button>
					<b-button variant="primary " @click="uploadCsv" :disabled="!previewDataClicked">Upload Data</b-button>
					<b-button variant="danger" @click="clearData">Clear Data</b-button>
				</div>
				
			</div>

			<div class="mb-3" v-if="!loadingStatus">
				<b-row>
					<b-col cols="12" xl="8" lg="7" md="7" sm="6">
						<b-form-group v-if="false"
							label=""
							label-for="per-page-select"
							label-cols-sm="0"
							label-cols-md="0"
							label-cols-lg="0"
							label-align-sm="center"
							label-size="sm"
							class="mb-2 per-page-select"
						>
							<label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
							<b-form-select
								id="per-page-select"
								class="diameter-report-select"
								v-model="perPage"
								:options="pageOptions"
								size="sm"
								v-on:input="changePageOption(perPage)"
							></b-form-select>
						</b-form-group>
					</b-col>
					<b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
						<b-form-group v-if="false"
							label=""
							label-for="filter-input"
							label-align-sm="right"
							label-size="sm "
							class="mb-0 per-page-select"
						>
							<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
							<b-input-group size="sm">
								<b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
							</b-input-group>
						</b-form-group>
					</b-col>
				</b-row>
				<b-table
					v-if="previewDataClicked"
					striped
					hover
					:items="tableData"
					:fields="tableColumns"
					:current-page="currentPage"
					:per-page="perPage"
					:filter="filter"
					:filter-included-fields="filterOn"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					:sort-direction="sortDirection"
					head-variant="light"
					table-class="text-nowrap"
					class="data-management-table primary-table"
					sticky-header="true"
					thead-class="white"
					show-empty
					responsive
					small
					@filtered="onFiltered"
				>
					
				</b-table>
				<b-row class="mt-4" v-if="previewDataClicked">
					<b-col >
						<p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
					</b-col>
					<b-col >
						<b-pagination
							class="flex-fill-custom pr-4 ml-3 justify-content-end"
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
							size="sm"
						></b-pagination>
					</b-col>
				</b-row>
			</div>

			<b-modal 
				v-model="uploadModal" 
				hide-footer
				centered
				size="lg"
				id="upload-nsim"
				title="Upload NSIM GT"
				class="Upload-Nsim"
				:no-close-on-backdrop="true"
  				:no-close-on-esc="true"
			>
				<!-- Progress bar -->
				<b-progress :value="progress" :max="totalRows" :show-progress="true"></b-progress>
			</b-modal>
		</div>
	</transition>
</template>
<script>
import productManagementService from "../../../../common/api-services/product-management-service";
import swal from "sweetalert2";
import handleResponse from "../../../../common/directive/handlResponse";
import TagsInput from "@/components/Inputs/TagsInput";
import pagination from '../../../../common/format/pagination'
import Papa from "papaparse";

export default {
	name: "NsimList",
	components: {TagsInput},
	data() {
		return {
			file1: null,
			previewDataClicked: false,
			show: "Show Data",
			usersForm: {
				group: [], //'Select Group',
			},
			groupOption: [],
			loadingStatus: false,
			totalRows: 0,
			currentPage: 1,
			pageOptions: [10, 25, 50, 100],
			perPage: 10,
			tableColumns: [
				{key: "gt", label: "GT", sortable: true, sortDirection: "desc"},
				{key: "metric", label: "Metric", sortable: true, sortDirection: "desc"},
				{key: "name", label: "Name", sortDirection: "desc"},
				{key: "carrier", label: "Carrier", sortDirection: "desc"},
				{key: "location", label: "Location", sortable: true, sortDirection: "desc"},
				{key: "tadig", label: "Tadig", sortable: true, sortDirection: "desc"},
				{key: "sigla", label: "Sigla ", sortable: true, sortDirection: "desc"},
			],
			tableData: [],
			localData: [],
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			filterOn: [],
			uploadModal: false,
			progress: 0,
			success: 0,
		};
	},
	mounted() {

	},
	methods: {

		changePageOption(page) {
			this.getTotalRows();
		},

		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},
		startPage() {
		   return pagination.startPageFunc(this.currentPage, this.perPage)
		}, 
		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
      	},

		deleteNsim(customerId) {
			swal.fire({
				title: `Nsim`,
				text: `Delete selected portal Nsim? ${customerId}`,
				buttonsStyling: false,
				showCloseButton: true,
				showCancelButton: true,

				confirmButtonText: "Delete",
				confirmButtonClass: "btn btn-danger",

				cancelButtonText: "Cancel",
				cancelButtonClass: "btn btn-info",
			}).then(result => {
				if (result.isConfirmed) {
					productManagementService.deleteNsim(customerId).then(res => {
						let {type, msg} = handleResponse.apiResponse(res);
						this.$toast(msg, {type: type})
						this.getNsimListFunc();
					});
				}
			});
		},

		handleFileInputChange(event) {
			const file = event.target.files[0];

			// Check if a file was selected
			if (!file) {
				return;
			}

			// Read the file as text
			const reader = new FileReader();
			reader.onload = () => {
				const csvData = reader.result;
				this.parseCSV(csvData);
			};
			reader.readAsText(file);
			this.previewDataClicked = true;
		},

		parseCSV(csvData) {
			this.localData = [];
			this.totalRows = 0;
			this.tableData = [];
			// Parse the CSV data
			const parsedData = Papa.parse(csvData, { header: true }).data;

			// Map the parsed data to tableData
			parsedData.map(item => {
				let child = {
					gt: item.gt,
					metric: item.metric,
					name: item.name,
					carrier: item.carrier,
					location: item.location,
					tadig: item.tadig,
					sigla: item.sigla,
				};
				this.tableData.push(child);
			});
			this.localData = this.tableData;
			this.totalRows = this.tableData.length;
		},

		previewData() {
			// Set previewDataClicked to true to display the table
			this.previewDataClicked = true;
		},

		async downloadCsv(){
			const fileName = "NSIM_GT.csv";

			try {
				const response = await productManagementService.downloadNsimGT();
				const blobUrl = URL.createObjectURL(response.data);

				const a = document.createElement("a");
				a.href = blobUrl;
				a.download = fileName;
				a.click();

				URL.revokeObjectURL(blobUrl);
			} catch (error) {
				console.error("Error downloading the file:", error);
			}
		},

		async uploadCsv(){
			this.uploadModal = true;
			for (const item of this.tableData) {
				let payload = {
					gt: item.gt,
					metric: item.metric,
					name: item.name,
					carrier: item.carrier,
					location: item.location,
					tadig: item.tadig,
					sigla: item.sigla,
					nocache: 1,
				};

				if (payload.gt == undefined || payload.gt == null || payload.gt == '') {
					continue;
				}
					
				await productManagementService.InsertNSIMGTData(payload).then(res => {
					this.progress++;
					if (res === undefined) {
						// console.log('Upload ERROR', payload.name)
						return;
					}
					if (!res.includes('FAIL')) {
						console.log('Upload SUCCESS', payload.name)
						this.success++;
					}else{
						let {type, msg} = handleResponse.apiResponse(res);
						this.$toast(msg, {type: type})
					}
				})
				.catch(err => {
					console.log(err);
				});
			};
			console.log({success: this.success, total: this.totalRows});
			this.$toast(`${this.success} of ${this.totalRows} uploaded successfully`+'\n'+`${this.totalRows - this.success} duplicate codes skipped`, {type: 'success'});
			this.modalClose();
		},

		modalClose() {
			this.$root.$emit('getNsimListFunc');
			this.progress = 0;
			this.success = 0;
			this.uploadModal = false;
		},

		async clearData(){
			//delete the table.
			swal.fire({
				title: "NSIM GT",
				text: "Delete all NSIM GT records?",
				buttonsStyling: false,
				showCloseButton: true,
				showCancelButton: true,

				confirmButtonText: "Delete",
				confirmButtonClass: "btn btn-danger",

				cancelButtonText: "Cancel",
				cancelButtonClass: "btn btn-info",
			}).then(result => {
				if (result.isConfirmed) {
					productManagementService.ClearNSIMGT().then(res => {
						let {type, msg} = handleResponse.apiResponse(res);
						this.$toast(msg, {type: type})
					});
				}
			});
		}

	},
	
};
</script>

<style>
/* Hide the "x" button in the modal header */
#upload-nsim .close {
  display: none;
}
</style>
